import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxlcc_airline_booking_details';
export const route = 'cnxlcc_airline_booking_details/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxlcc_airline_booking_details" */
/* webpackPrefetch: true */
'../components/AirlineBookingDetailsPage')));